import React, { useEffect, useMemo } from "react";

import { Box, CircularProgress } from "@mui/material";
import HeightCalculator from "./HeightCalculator";

export const PTCircular = ({ children, isCircul, minHeight, minWidth, ...props }) => {
  const memoizedChildren = useMemo(() => children, [children]);
  return (
    <HeightCalculator>
      {(dimension) => {
        if (isCircul)
          return ( 
            <div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: minHeight || dimension.height,
                  width: minWidth || dimension.width,
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          );
        return <>{memoizedChildren}</>;
      }}
    </HeightCalculator>
  );
};

export default PTCircular;
